import {SPIELER_ACTION_FIELD_SETTINGS} from "./spielerActionFieldSettings";

export default class SPIELER_ACTION_LISTS  {

    /*createdAt: {excel: 'Erstellt am', app: 'Erstellt am', type: 'data'},
    createdByName: {excel: 'Erstellt von', app: 'Erstellt von', type: 'string'},
    actionType: {excel: 'Aktin', app: 'Aktion', type: 'string'},
    changes: {excel: 'Änderungen', app: 'Änderungen', type: 'string'},
    comment: {excel: 'Bemerkungen', app: 'Bemerkungen', type: 'string'},
    processedByName: {excel: 'Verarbeitet von', app: 'Verarbeitet von', type: 'string'},
    processedAt: {excel: 'Verarbeitet am', app: 'Verarbeitet am', type: 'string'},
    processed: {excel: 'Erledigt', app: 'Erledigt', type: 'string'},*/


    static getTableHeaders(table){
        let columnList = [];
        switch (table) {
            case 'paesseInfo':
                columnList = ['spielerFull', 'createdAt', 'createdByName',
                              'actionType', 'changesRaw', 'processed', 'excel'];
                break;
            case 'paesseInfoNeu':
                columnList = ['spielerFull', 'createdAtSortable', 'createdByName',
                              'actionType', 'changesRaw'];
                break;
            case 'paesseInfoNeuExcel':
                columnList = ['nachname', 'vorname', 'nationalitaetSpieler', 'passNrFull', 'vereinsNrFull',
                              'vereinsName', 'spielerFull', 'createdAt', 'createdByName',
                              'actionType', 'changesRaw'];
                break;
            case 'spielerInfoLog':
                columnList = ['createdAtSortable', 'createdByName', 'actionType', 'changesRaw', 'processed'];
                break;
            case 'passDuplikat':
                columnList = ['createdAt', 'createdByName', 'status_lvNr', 'vereinsNr', 'passNr',
                              'nachname', 'vorname'];
                break;
            case 'edit':
                columnList = ['createdAt', 'createdByName', 'vereinPass',
                              'nachname', 'changesRaw'];
                break;
        }
        return this.getTableHeaderList(columnList)
    }

        static getTableHeaderList(columnList){
            let headerList = [];
            columnList.forEach( (column) => {
                headerList.push({
                    text: SPIELER_ACTION_FIELD_SETTINGS[column].app,
                    value: column,
                    sortable: true
                })
            });
            return headerList;
        }

    static getTableItem(table, dataItem){
        let columnList = [];
        switch (table) {
            case 'paesseInfo':
                columnList = ['spielerFull', 'createdAt', 'createdByName',
                              'actionType', 'changesRaw', 'processed', 'excel'];
                break;
            case 'paesseInfoNeu':
                columnList = ['spielerFull', 'createdAtSortable', 'createdByName',
                              'actionType', 'changesRaw'];
                break;
            case 'paesseInfoNeuExcel':
                columnList = ['nachname', 'vorname', 'nationalitaetSpieler', 'passNrFull', 'vereinsNrFull',
                              'spielerFull', 'createdAt', 'createdByName',
                              'actionType', 'changesRaw'];
                break;
            case 'spielerInfoLog':
                columnList = ['createdAtSortable', 'createdByName', 'actionType', 'changesRaw', 'processed'];
                break;
            case 'passDuplikat':
                columnList = ['createdAt', 'createdByName', 'status_lvNr', 'vereinsNr', 'passNr',
                              'nachname', 'vorname', 'id'];
                break;
            case 'edit':
                columnList = ['createdAt', 'createdByName', 'vereinPass',
                              'nachname', 'changesRaw', 'id'];
                break;
        }
        return this.getTableItemData(columnList, dataItem)
    }

        static getTableItemData(columnList, dataItem){
            let item = {};
            columnList.forEach( (column) => {
                let field = SPIELER_ACTION_FIELD_SETTINGS[column];
                if ( field.formatValue ) {
                    item[column] = field.formatValue(dataItem);
                } else {
                    item[column] = field.childOf ? dataItem[field.childOf][column] : dataItem[column];
                }
            });
            return item;
        }
}